// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminPoSettings = (client) => ({
    /**
     * `POST /admin/po-settings`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminUpsertPoSettings
     * @source packages/medusa-plugin-po-payment-v2/src/api/admin/po-settings/route.ts
     */
    create: (body, query, headers) => client.fetch("/admin/po-settings", { method: "POST", body, query, headers }),
    /**
     * `GET /admin/po-settings`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetPoSettings
     * @source packages/medusa-plugin-po-payment-v2/src/api/admin/po-settings/route.ts
     */
    list: (query, headers) => client.fetch("/admin/po-settings", { method: "GET", query, headers }),
});
//# sourceMappingURL=po-settings.js.map